module.exports = __webpack_public_path__ + "img/addPicture.354be602.png";